import * as yup from 'yup';

export const newticketSchema = yup.object().shape({
  customerName: yup.string().required('Customer name is required'),
  customerEmail: yup.string().email('Invalid email address').required('Customer email is required'),
  categoryId: yup.string().uuid('Invalid category ID').required('Category ID is required'),
  assignedUserId: yup.string().uuid('Invalid assigned user ID').required('Assigned user ID is required'),
  priority: yup.string().oneOf(['LOW', 'MEDIUM', 'HIGH']).required('Priority is required'),
  subject: yup.string().required('Subject is required'),
  message: yup.string().required('Message is required'),
});

export const singleAssignTicket = yup.object().shape({
  ticketId: yup.string(),
  ticketStatus: yup.string().required('Ticket Status is required'),
  assignUserId: yup.string().required('UserId is required'),
  dueDate: yup.string().required('DueDate is required'),
  priority: yup.string().required('Priority is required'),
})
// .required('TicketId is required')
// .required('Ticket Status is required')
// .required('UserId is required')
// .required('DueDate is required')
// .required('Priority is required')

export const builkAssignTicket = yup.object().shape({
  priority: yup.string().required('Priority is required'),
  dueDate: yup.string().required('DueDate is required'),
  userToAssign: yup.string().required('UserId is required'),
})